import { useState } from 'react'
import { pageSizeConfigs } from 'Main/Utils'
import LogUserFilter from 'views/components/Input/LogUserFilter'

const STATUS_OPTIONS = [
  ['200', '200 (Success)'],
  ['204', '204 (No Content)'],
  ['400', '400 (Bad Request)'],
  ['500', '500 (Server Error)']
]

export function GlobalCallbackLogsToolbar ({ filters, options, showUserFilter, users, loadingUsers, onFieldChange, onClear }) {
  const [filtersOpen, setFiltersOpen] = useState(false)
  const { type, paymentVendorsId, qrisExtConfigsId, endpoint, status, from, to, userId, pageSize } = filters
  const { types, vendors, configs, endpoints } = options

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-end mb-2">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={() => setFiltersOpen((current) => !current)}
          aria-expanded={filtersOpen}
          aria-controls="global-callback-logs-filters"
        >
          <i className={`fa-solid ${filtersOpen ? 'fa-angle-up' : 'fa-filter'} me-1`} />
          {filtersOpen ? 'Hide filters' : 'Show filters'}
        </button>
      </div>

      <div className={`collapse ${filtersOpen ? 'show' : ''}`} id="global-callback-logs-filters">
        <form className="row g-2" onSubmit={(e) => e.preventDefault()}>
          {showUserFilter && (
            <LogUserFilter
              value={userId}
              users={users}
              loading={loadingUsers}
              onChange={(e) => onFieldChange('userId', e.target.value)}
            />
          )}
          <div className="col-6 col-md-2">
            <label className="form-label small text-muted mb-1">Type</label>
            <select className="form-select" value={type} onChange={(e) => onFieldChange('type', e.target.value)}>
              <option value="%">All Types</option>
              {types.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>

          <div className="col-6 col-md-3">
            <label className="form-label small text-muted mb-1">Vendor Gateway</label>
            <select
              className="form-select"
              value={paymentVendorsId}
              onChange={(e) => onFieldChange('paymentVendorsId', e.target.value)}
            >
              <option value="">All Vendors</option>
              {vendors.map((v) => (
                <option key={v.id} value={v.id}>
                  {v.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-3">
            <label className="form-label small text-muted mb-1">QRIS Config</label>
            <select
              className="form-select"
              value={qrisExtConfigsId}
              onChange={(e) => onFieldChange('qrisExtConfigsId', e.target.value)}
            >
              <option value="">All Configs</option>
              {configs.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-4">
            <label className="form-label small text-muted mb-1">Callback URL</label>
            <select className="form-select" value={endpoint} onChange={(e) => onFieldChange('endpoint', e.target.value)}>
              <option value="%">All Endpoints</option>
              {endpoints.map((ep) => (
                <option key={ep} value={ep}>
                  {ep}
                </option>
              ))}
            </select>
          </div>

          <div className="col-6 col-md-2">
            <label className="form-label small text-muted mb-1">From</label>
            <input
              type="date"
              className="form-control"
              value={from}
              onChange={(e) => onFieldChange('from', e.target.value)}
            />
          </div>

          <div className="col-6 col-md-2">
            <label className="form-label small text-muted mb-1">To</label>
            <input type="date" className="form-control" value={to} onChange={(e) => onFieldChange('to', e.target.value)} />
          </div>

          <div className="col-6 col-md-2">
            <label className="form-label small text-muted mb-1">Status Code</label>
            <select className="form-select" value={status} onChange={(e) => onFieldChange('status', e.target.value)}>
              <option value="%">All Status</option>
              {STATUS_OPTIONS.map(([val, label]) => (
                <option key={val} value={val}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          <div className="col-6 col-md-1">
            <label className="form-label small text-muted mb-1">Size</label>
            <select className="form-select" value={pageSize} onChange={(e) => onFieldChange('pageSize', e.target.value)}>
              {pageSizeConfigs.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-2 d-flex align-items-end ms-auto gap-2">
            <button type="button" className="btn btn-light text-black flex-fill" onClick={onClear}>
              <i className="fa-solid fa-rotate-left" /> Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default GlobalCallbackLogsToolbar